import { render, staticRenderFns } from "./mspDetails.vue?vue&type=template&id=4b70cc1f&scoped=true&"
import script from "./mspDetails.vue?vue&type=script&lang=js&"
export * from "./mspDetails.vue?vue&type=script&lang=js&"
import style0 from "./mspDetails.vue?vue&type=style&index=0&id=4b70cc1f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b70cc1f",
  null
  
)

export default component.exports